export namespace Domain {
  export interface IDeviceInfo {
    gatewayId: string;
    meterId: number;
    updateTimestamp: Date;
  }

  export interface IRealTimedata {
    // mongodb

    _id: string;
    getewayId: string;
    meterId: number;
    /** UTC timestamp */
    timestamp: Date;
    /** 進出水溫 超溫告警 */
    overTemperatureAlarm: boolean;
    /** 冰水入水溫度 單位 0.1 度  */
    iceWaterInTemperature: number;
    /** 冰水出水溫度 單位 0.1 度  */
    iceWaterOutTemperature: number;
    /** 冷卻水出水溫度 單位 0.1 度  */
    coolingWaterOutTemperature: number;
    /** 冷卻水入水溫度 單位 0.1 度  */
    coolingWaterInTemperature: number;
    /** 冷媒低溫溫度 單位 0.1 度 */
    refrigerantTemperature: number;
    /** 油槽溫度 單位 0.1 度 */
    oilTankTemperature: number;
    /** 平均電壓 單位 1 V */
    averageVoltage: number;
    /** 平均電流 單位 0.1 A */
    averageCurrent: number;
    /** 平均功率 單位 0.1 kW */
    averagePower: number;
    /** 平均功因 單位 0.001 */
    averagePowerFactor: number;
    /** 電力計0.1 kW */
    averagekW: number;
    /** A機電流 0.1 A */
    devACurrent: number;
    /** B機電流 0.1 A */
    devBCurrent: number;
    /** A機功率 0.1 kW */
    devAPower: number;
    /** B機功率 0.1 kW */
    devBPower: number;
    /** A機高壓壓力 0.1 KG */
    devAHighPressure: number;
    /** A機低壓壓力 0.1 KG */
    devALowPressure: number;
    /** B機高壓壓力 0.1 KG */
    devBHighPressure: number;
    /** B機低壓壓力 0.1 KG */
    devBLowPressure: number;
    /** 冷媒低溫設定 單位 0.1 度 */
    refrigerantLowTemperatureSetting: number;
    /** 冰水溫度設定 單位 0.1 度 */
    iceWaterTemperatureSetting: number;
    /** 溫度控制設定 */
    temperatureControl: TemperatureControlMode;
    /** 需量控制開關 */
    aDRControlState: boolean;
    /** A機負載限制 0.1 % */
    devAMaxLoad: number;
    /** A機最高頻率 0.1 Hz */
    devAMaxFrequency: number;
    /** A變頻器輸出頻率 0.1 Hz */
    devAInverterOutFrequency: number;
    /** B機需量運轉率50%  */
    devBRunning50: boolean;
    /** B機需量運轉率75% */
    devBRunning75: boolean;
    /** B機強制運轉率25% */
    devBForceRunning25: boolean;
    /** B機強制運轉率50% */
    devBForceRunning50: boolean;
    /** B機強制運轉率75% */
    devBForceRunning75: boolean;
    /** A機故障 */
    devAFailure: boolean;
    /** B機故障 */
    devBFailure: boolean;
    /** 緊急開關作動 */
    emergencyStart: boolean;
    /** 冷卻水流開關警報 */
    coolingAlarm: boolean;
    /** 冰水水流開關警報 */
    iceWaterAlarm: boolean;
    /** 防凍開關警報 */
    antifreezeAlarm: boolean;
    /** 電源保護開關警報 */
    powerProtectionAlarm: boolean;
    /** A機高壓保護警報 */
    devAHighPressureAlarm: boolean;
    /** B機高壓保護警報 */
    devBHighPressureAlarm: boolean;
    /** B機過載保護警報 */
    devBOverLoadAlarm: boolean;
    /** A機吐出線圈保護警報 */
    devACoilAlarm: boolean;
    /** B機吐出線圈保護警報 */
    devBCoilAlarm: boolean;
    /** A機低壓保護警報 */
    devALowPressureAlarm: boolean;
    /** B機低壓保護警報 */
    devBLowPressureAlarm: boolean;
    /** A機油壓差保護警報 */
    devAOilPressureAlarm: boolean;
    /** B機油壓差保護警報 */
    devBOilPressureAlarm: boolean;
    /** 保養時數到達 */
    needMaintenance: boolean;
    /** 變頻器異常 */
    inverterAbnormal: boolean;
    /** 油位保護 */
    oilProtection: boolean;
    /** 冷媒低溫異常警報 */
    refrigerantAbnormal: boolean;
    /** 冰水回水感溫棒故障警報 */
    iceWaterInSensorAlarm: boolean;
    /** 冰水出水感溫棒故障警報 */
    iceWaterOutSensorAlarm: boolean;
    /** 冷卻回水感溫棒故障警報 */
    coolingWaterInSensorAlarm: boolean;
    /** 冷卻出水感溫棒故障警報 */
    coolingWaterOutSensorAlarm: boolean;
    /** 冷媒低溫感溫棒故障警報 */
    refrigerantLowTemperatureSensorAlarm: boolean;
    /** 油槽溫度感溫棒故障警報 */
    oilTankTemperatureSensorAlarm: boolean;
    /** A機運轉狀況 */
    devAState: DevARunningState;
    /** B機運轉狀況 */
    devBState: DevBRunningState;
    /** A機運轉時間 */
    devARunningTime: number;
    /** A機啟動次數 */
    devAStartCount: number;
    /** B機運轉時間 */
    devBRunningTime: number;
    /** B機啟動次數 */
    devBStartCount: number;
    /** 遠控信號旗標 */
    remoteControlSingal: boolean;
  }
  export enum TemperatureControlMode {
    /** 冰水出水控制 */
    IceWaterOut = 0x0,
    /** 冰水回水控制 */
    IceWaterIn = 0x1
  }
  export enum DevARunningState {
    /** 停機 */
    Stop = 0x0,
    /** 延時啟動 */
    DelayStart = 0x1,
    /** 變頻運轉2 */
    VariableStart2 = 0x2,
    /** 變頻運轉5 */
    VariableStart5 = 0x5,
    /** 主機故障 */
    MainFailure = 0x6,
    /** 維護中 */
    Maintenance = 0x7,
    /** 溫度到達 */
    ReachTemperature = 0x8,
    /** 卸載停機中 */
    DemandShutdown = 0x9
  }
  export enum DevBRunningState {
    /** 停機 */
    Stop = 0x0,
    /** 延時啟動 */
    DelayStart = 0x1,
    /** 容量 25%運轉 */
    On25 = 0x2,
    /** 容量 50%運轉 */
    On50 = 0x3,
    /** 容量 75%運轉 */
    On75 = 0x4,
    /** 容量滿載運轉 */
    OnFull = 0x5,
    /** 溫度到達 */
    MainFailure = 0x6,
    /** 維護中 */
    Maintenance = 0x7,
    /** 溫度到達 */
    ReachTemperature = 0x8,
    /** 卸載停機中 */
    DemandShutdown = 0x9
  }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/lib/Domain/LWFSeries/index.ts